<!-- Search and NEW -->
<div class="flexie-auto-grid p-b-20">
  <div>
    <h3 translate>Search</h3>
    <app-ui-search [(SearchCriteria)]="CRITERIALOOKUP" (componentOutput)="fetchSearchResult($event)" searchURL="claim/Intimation/search"
      itemsPerPage='100'></app-ui-search>
  </div>
  <div class="text-a-right">
    <button *ngIf="viewType != 'ENQUIRY'" nz-button [nzType]="'primary'" (click)="NewIntimation('workbench')" translate>
      <i nz-icon nzType="plus"  nzTheme="outline"></i> New Intimation
    </button>
  </div>
</div>

<!-- <h3 class="heading" translate>Last 5 Intimations</h3> -->
<h3 class="heading" translate>Latest Intimations Worked On</h3>

<!-- Data -->
<nz-table *ngIf="dataSet && dataSet.length > 0" #intimationSearchTable [nzData]="dataSet" [nzSize]="'middle'" [nzScroll]="{ x: '1500px'}">
  <thead>
    <tr>

      <th>Policy No</th>
      <th>Intimation No</th>
      <th>Client Name</th>
      <th>Claimant Name</th>
      <th>Claimant Telephone No</th>
      <th>Claimant email</th>
      <th>Intimation Date</th>
      <th>Intimation Status</th>
      <th>Event Type</th>
      <th>Event Date</th>

    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let data of intimationSearchTable.data">
      <td>{{data.policyNum}}</td>
      <td><a (click)="openTransactionDetails('claimIntimation',data.guid,'workbench')">{{data.intimationNum}}</a></td>
      <td>{{data.insuredFirstName }} {{data.insuredLastName}} </td>
      <td>{{data.claimantFirstName }} {{data.claimantLastName}} </td>
      <td>{{data.claimantPhNo}}</td>
      <td>{{data.claimantEmail}}</td>
      <td>{{getDateString(data.intimationDt)}}</td>
      <td>{{data.statusCd}}</td>
      <td>{{data.eventType}}</td>
      <td>{{getDateString(data.eventDt)}}</td>
    </tr>
  </tbody>
</nz-table>
<app-generic-zero-ui [list]="dataSet" icon="file-search" 
[title]="intimationZeroState.title" [message]="intimationZeroState.message" [icon]="intimationZeroState.icon"></app-generic-zero-ui>